import React from 'react'
import cloudThree from '../../images/small-cloud-two.svg'
import styles from "./animation.module.css"


export default class CloudThree extends React.Component {

  render(){
    return (
             
                <div className={styles[`animateCloudThree`]}
                    css={{position:`absolute`,
                          top:`37%`,
                          bottom:`0`,
                          left:`50%`,
                          width:`100%`,
                          height:`100%`,
                          '@media(min-width:400px)':{
                             top:'52%'
                          },
                          '@media(min-width:800px)':{
                             top:'30%',
                             left:'40%',
                          }

                           }}>

                    <img src={cloudThree} 
                        alt="cloud three" 
                        style={{ width:'100%',
                                 height:'120%',
                                 transform:'scale(.5)', 
                                 filter:'drop-shadow(rgba(0, 0, 0, 0.045) -10px -10px 10px)'
                               }} />
                </div>
            
      )
  }
}
